import axios from 'axios';

const deleteBankAccountImageApi = async (values, token, langIsoCode) => {
  const url = '/Auth_private/deleteBankImage';
  try {
    const res = await axios.post(url, values, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default deleteBankAccountImageApi;
